import React from "react";
import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
export const EditorMentionMenuTitle = ({ children, }) => {
    return (React.createElement("div", { className: "editor-mention-menu-title" },
        React.createElement(Paragraph, { size: "xs", weight: "semibold", color: "secondary" }, children)));
};
